<template>
  <p><slot /></p>
</template>
